export default __webpack_public_path__ + "static/media/Projects-Logo.59c6eb2e.png";